// extracted by mini-css-extract-plugin
export default {"mainContacto":"Contacto_mainContacto__kc986"};